import src from "IMAGE";
export default { src, width: 418, height: 252, blurWidth: 0, blurHeight: 0};
